"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UseDeleteSignalement = UseDeleteSignalement;
const react_1 = require("react");
const yup_1 = require("@hookform/resolvers/yup");
const react_hook_form_1 = require("react-hook-form");
const sweetalert2_1 = __importDefault(require("sweetalert2"));
const yup = __importStar(require("yup"));
const signalement_api_1 = require("../../../../utils/api/signalement/signalement.api");
const theme_1 = require("../../../../utils/theme");
const Utils_1 = require("../../../../utils/Utils");
const hook_1 = require("../../../../redux/hook");
const UseCrudSignalement = (handleClose, signalement) => {
    const [mediaImage, setMediaImage] = (0, react_1.useState)();
    const [mediaAudio, setMediaAudio] = (0, react_1.useState)();
    const [mediaVideo, setMediaVideo] = (0, react_1.useState)();
    const validationSchema = yup.object().shape({
        content: yup.string().required("Le contenu est requis."),
        hasEdit: yup.boolean(),
    });
    const { user } = (0, hook_1.useAppSelector)((state) => state.user);
    const { register, handleSubmit, formState: { errors }, setValue, clearErrors, reset, } = (0, react_hook_form_1.useForm)({
        resolver: (0, yup_1.yupResolver)(validationSchema),
        defaultValues: {
            added_by: user.user_id,
        },
    });
    const [addOrUpdateSignalement, { isLoading, isSuccess, error, isError }] = (0, signalement_api_1.useAddOrUpdateSignalementMutation)();
    (0, react_1.useEffect)(() => {
        var _a, _b;
        if (isSuccess) {
            sweetalert2_1.default.fire({
                icon: "success",
                title: `Signalement ${signalement ? "modifié" : "ajouté"} avec succès!`,
                iconColor: theme_1.Color.success,
                showConfirmButton: false,
                timer: 1200,
            }).then(() => {
                if (!signalement) {
                    reset();
                    setMediaImage(null);
                    setMediaAudio(null);
                    setMediaVideo(null);
                }
                handleClose();
            });
        }
        const err = error;
        if (isError) {
            sweetalert2_1.default.fire({
                icon: "error",
                title: ((_a = err === null || err === void 0 ? void 0 : err.data) === null || _a === void 0 ? void 0 : _a.message)
                    ? (_b = err === null || err === void 0 ? void 0 : err.data) === null || _b === void 0 ? void 0 : _b.message
                    : `Erreur de statut ${err === null || err === void 0 ? void 0 : err.status}`,
                showConfirmButton: false,
                timer: 5000,
            });
        }
    }, [isLoading]);
    (0, react_1.useEffect)(() => {
        (0, Utils_1.cleannerError)(errors, clearErrors);
    }, [errors, clearErrors]);
    const onSubmit = (0, react_1.useCallback)((data) => __awaiter(void 0, void 0, void 0, function* () {
        // Validation: au moins un média doit être présent
        if (!mediaImage && !mediaAudio && !mediaVideo) {
            sweetalert2_1.default.fire({
                icon: "error",
                title: "Erreur",
                text: "Vous devez au moins ajouter une image, un audio ou une vidéo.",
                showConfirmButton: false,
                timer: 3000,
            });
            return;
        }
        const fd = new FormData();
        if (data.hasEdit) {
            fd.append("_method", "PUT");
        }
        if (mediaImage) {
            fd.append("media_image", mediaImage);
        }
        if (mediaAudio) {
            fd.append("media_audio", mediaAudio);
        }
        if (mediaVideo) {
            fd.append("media_video", mediaVideo);
        }
        fd.append("content", data.content);
        fd.append("added_by", user.user_id);
        yield addOrUpdateSignalement({ id: signalement === null || signalement === void 0 ? void 0 : signalement.id, data: fd });
    }), [signalement === null || signalement === void 0 ? void 0 : signalement.id, addOrUpdateSignalement, mediaImage, mediaAudio, mediaVideo, user.user_id]);
    (0, react_1.useEffect)(() => {
        if (signalement === null || signalement === void 0 ? void 0 : signalement.id) {
            setValue("hasEdit", true);
            setValue("content", (signalement === null || signalement === void 0 ? void 0 : signalement.content) || "");
            setMediaImage(signalement === null || signalement === void 0 ? void 0 : signalement.media_image);
            setMediaAudio(signalement === null || signalement === void 0 ? void 0 : signalement.media_audio);
            setMediaVideo(signalement === null || signalement === void 0 ? void 0 : signalement.media_video);
        }
        else {
            setValue("hasEdit", false);
        }
    }, [signalement, setValue]);
    const handleMediaImageChange = (file) => {
        setMediaImage(file);
        setValue("media_image", file);
    };
    const handleMediaAudioChange = (file) => {
        setMediaAudio(file);
        setValue("media_audio", file);
    };
    const handleMediaVideoChange = (file) => {
        setMediaVideo(file);
        setValue("media_video", file);
    };
    return {
        register,
        errors: errors,
        onSubmit: handleSubmit(onSubmit),
        setValue,
        isLoading,
        reset,
        mediaImage,
        setMediaImage,
        mediaAudio,
        setMediaAudio,
        mediaVideo,
        setMediaVideo,
        handleMediaImageChange,
        handleMediaAudioChange,
        handleMediaVideoChange,
    };
};
exports.default = UseCrudSignalement;
function UseDeleteSignalement(id) {
    const [deleteData] = (0, signalement_api_1.useDeleteSignalementMutation)();
    const onDelete = () => __awaiter(this, void 0, void 0, function* () {
        yield sweetalert2_1.default.fire({
            title: `Êtes-vous sûr de vouloir supprimer ce signalement ?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "OUI",
            cancelButtonText: "NON",
            showLoaderOnConfirm: true,
            iconColor: theme_1.Color.themeColor,
            confirmButtonColor: theme_1.Color.themeColor,
            preConfirm: () => {
                return deleteData(id);
            },
            allowOutsideClick: () => !sweetalert2_1.default.isLoading(),
        }).then((result) => {
            if (result === null || result === void 0 ? void 0 : result.value) {
                sweetalert2_1.default.fire({
                    icon: "success",
                    title: `Signalement supprimé avec succès!`,
                    iconColor: theme_1.Color.themeColor,
                    showConfirmButton: false,
                    timer: 1500,
                });
            }
        });
    });
    return onDelete;
}
